module.exports = __webpack_public_path__ + "static/key-littlebigworkshop-befeae06e81a069b294098c679a901a8.webp";